import { render, staticRenderFns } from "./ProjectUsersAutocomplete.vue?vue&type=template&id=404b446c&lang=pug"
import script from "./ProjectUsersAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProjectUsersAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports